<template>
  <a-modal
    v-model:visible="modalConfig.visible"
    :title="modalConfig.title"
    @ok="handleOk"
    @cancel="handleCancel"
    :width="800"
  >
    <a-form :model="formState" :rules="rules" ref="formRef">
      <a-form-item label="闭环状态" v-if="props.closedLoopAuthority">
        <a-select
          v-model:value="formState.closedLoopStatus"
          placeholder="闭环状态"
          allowClear
        >
          <a-select-option value="不适用"> 不适用 </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="质检">
        <question-vue
          ref="questionRef"
          title="送检问题"
          :disabled="true"
          :questionDesc="formState.inspectionIssues"
        >
        </question-vue>
      </a-form-item>

      <a-form-item label="备注">
        <content-dsc-vue
          :question="formState.notes"
          ref="notesRef"
          :disabled="true"
        ></content-dsc-vue>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { timeStampToTime, Toast } from "@/utils";
import { computed, defineComponent, reactive, ref } from "vue";
import { useStore } from "vuex";
import {
  saveOrUpdatePQCThreeMajorItems,
  saveOrUpdatePQCReferenceArm,
  saveOrUpdatePQCCompleteReferenceArm,
  saveOrUpdatePQCCalibrate,
  saveOrUpdatePQCAssembleDebug,
  saveOrUpdateFQC,
  saveOrUpdateOQC,
} from "@/request/view/qualityInspection";

import { updatePQC } from "@/request/view/dailyQualityInspection";
import { updateFQC, updateOQC } from "@/request/view/warehouse";

import questionVue from "./question.vue";
import contentDscVue from "@/views/productDaily/components/quality/components/question.vue";

export default defineComponent({
  props: {
    type: String,
    closedLoopAuthority: Boolean,
  },
  components: { questionVue, contentDscVue },
  setup(props, context) {
    const store = useStore();
    const formRef = ref();
    const notesRef = ref();
    const modalConfig = reactive({
      visible: false,
      title: null,
    });

    const formState = reactive({
      batchNumber: null,
      closedLoopStatus: null,
      id: null,
      inspectionFrequency: null,
      inspectionIssues: null,
      isNewDevice: null,
      localDate: null,
      modelSpecifications: null,
      notes: null,
      outputSnNumber: null,
      produceOrTpc: null,
      productionInstructionId: null,
      productionTaskId: null,
      serialNumber: null,
      snNumber: null,
      sourceProcess: null,
      status: null,
      subordinateProcess: null,
      type: null,
      userId: null,
      username: null,
    });

    const isEdit = computed(() => {
      if (modalConfig.title === "添加质检数据") {
        return true;
      }
      return formState.userId === store.state.user.user.id;
    });

    const rules = {};

    const questionRef = ref();

    const resetForm = () => {
      Object.keys(formState).forEach((key) => {
        formState[key] = null;
      });
      formRef.value.clearValidate();
    };

    const handleCancel = () => {
      resetForm();
      modalConfig.visible = false;
      modalConfig.title = null;
    };

    const openModal = (type, data) => {
      modalConfig.visible = true;
      if (type === "addPQC") {
        modalConfig.title = "添加质检数据";
        formState.localDate = timeStampToTime("", "upload");
      } else if (type === "editPQC") {
        modalConfig.title = "编辑质检数据";
        Object.keys(formState).forEach((key) => {
          formState[key] = data[key];
        });
      }
      console.log(type, data, formState, "formState+++++++++++++++");
    };

    const handleOk = () => {
      try {
        formRef.value
          .validate()
          .then(async () => {
            formState.inspectionIssues = questionRef.value.uploadFile();
            if (props.type === "fqc") {
              updateFQC(
                {
                  isQualityInspection: 1,
                },
                formState
              )
                .then((res) => {
                  let type = res.code === 200 ? "success" : "warning";
                  Toast(type, res.message, 3);
                  handleCancel();
                  context.emit("updateTable");
                })
                .catch((err) => {
                  console.log(err);
                });
              return;
            }

            if (props.type === "oqc") {
              updateOQC(formState)
                .then((res) => {
                  let type = res.code === 200 ? "success" : "warning";
                  Toast(type, res.message, 3);
                  handleCancel();
                  context.emit("updateTable");
                })
                .catch((err) => {
                  console.log(err);
                });
              return;
            }
            updatePQC(formState)
              .then((res) => {
                let type = res.code === 200 ? "success" : "warning";
                Toast(type, res.message, 3);
                handleCancel();
                context.emit("updateTable");
              })
              .catch((err) => {
                console.log(err);
              });
          })
          .catch((err) => {
            console.log(err, "捕获错误");
            if (err.errorFields && err.errorFields.length > 0) {
              const [errText] = err.errorFields[0].errors;
              Toast("warning", errText, 3);
            }
          });
      } catch (error) {
        console.log(error, "catch 捕获错误");
      }
    };

    return {
      formRef,
      openModal,
      modalConfig,
      handleOk,
      handleCancel,
      formState,
      rules,
      questionRef,
      isEdit,
      notesRef,
      props,
    };
  },
});
</script>

<style lang="less" scoped>
</style>
